module.exports = __webpack_public_path__ + "onboarding-pkg-zip.a8c42bcb548918edab5f06f2a9396b3c.hashedasset.svg";